/**
 * Страница «Диета и диагностика» — /:lang/account/diet.
 *
 * Без ?tab она открывает «Рецепты», если они видны человеку (владелец,
 * 07.10.2026: «когда человек открывает вкладку диеты и диагностика, то он
 * заходит на рецепты, а не на продукты, в том числе когда заходит с
 * приложений»), иначе — «Диету», как раньше. Поэтому вход в раздел (нижняя
 * панель, плитка меню, окно приложения ?source=app) — без ?tab, а ссылка,
 * которая ведёт именно в диету (продукты: «Диета» в меню, результаты и заказ
 * диагностики диеты), — с ?tab=diet.
 */
export const DIET_PAGE_PATH = "/account/diet";

/** ?tab= вкладки «Диета» — явно: без него откроются «Рецепты». */
export const DIET_TAB = "diet";

/** «Диета» без языка — для меню и каталогов, где язык подставляют сами. */
export const DIET_TAB_PATH = `${DIET_PAGE_PATH}?tab=${DIET_TAB}`;

/** «Диета» на языке страницы: dietTabHref("ru") → "/ru/account/diet?tab=diet". */
export const dietTabHref = (lang: string): string => `/${lang || "ru"}${DIET_TAB_PATH}`;
